import React from "react";

import ActivityRoutesNormalXsmall from "@strava/icons/ActivityRoutesNormalXsmall";
import ActionsDownloadNormalXsmall from "@strava/icons/ActionsDownloadNormalXsmall";

import { LinkButton } from "@strava/ui/Button";

import { Map } from "@strava/feature-global-wasm-mre";

import I18n from "../../../utils/I18n";

import FullscreenToggle from "../FullscreenToggle/FullscreenToggle";

import styles from "./MapCustomControls.scss";

interface MapCustomControlsProps {
  createRouteURL?: string;
  gpxDownloadURL?: string;
  showMapTypeControl?: boolean;
  showFullScreenToggle?: boolean;
}

export const MapCustomControls = ({
  createRouteURL,
  gpxDownloadURL,
  showMapTypeControl = false,
  showFullScreenToggle = false
}: MapCustomControlsProps) => {
  return (
    <div className={styles.mapCustomControls}>
      {createRouteURL && (
        <LinkButton
          className={styles.linkButton}
          href={createRouteURL}
          data-testid="save-route-button"
        >
          <ActivityRoutesNormalXsmall />{" "}
          {I18n.t("mre.custom_control.create_route")}
        </LinkButton>
      )}
      {gpxDownloadURL && (
        <LinkButton
          className={styles.linkButton}
          href={gpxDownloadURL}
          data-testid="gpx-download-button"
        >
          <ActionsDownloadNormalXsmall />{" "}
          {I18n.t("mre.custom_control.export_gpx")}
        </LinkButton>
      )}
      {showMapTypeControl && <Map.MapTypeControl />}
      {showFullScreenToggle && <FullscreenToggle />}
    </div>
  );
};

export default MapCustomControls;
